import React, {useCallback, useMemo, useRef} from 'react'

import {useImportantAlertsContext} from '@hook/useImportantAlerts'

import WizCustomViewMenu from '@component/menu/WizMenu/WizCustomViewMenu'
import UserAccountComponent from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/UserAccountComponent'

import UserAccountInfo from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/UserAccountInfo'
import AccountOperationPages from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/AccountOperationPages'
import UserAccountList from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/UserAccountList'
import UserLogOutOperations from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/UserLogOutOperations'

import AccountImportantAlertModal from '@feature/account/components/importantAlert/AccountImportantAlertModal'
import SharePortfolioOptionModal from '@feature/portfolio/components/SharePortfolioOptionModal/SharePortfolioOptionModal'
import NotRegisteredApiModal from '@feature/portfolio/components/NotRegisteredApiModal/NotRegisteredApiModal'
import UserAccountThumbnailChangeInput from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/UserAccountThumbnailChangeInput'

interface IProps {
    className?: string
}

const marginTop = 15
const NavigationAccountOperationMenu = ({className}: IProps) => {
    const {alertList, invoiceAlertList, settingAlertList, proAlertList} = useImportantAlertsContext()

    const importantAlertModalRef = useRef<any>()
    const notRegisteredApiModalRef = useRef<any>()
    const sharePortfolioOptionModalRef = useRef<any>()

    const list = useMemo(() => {
        return [...invoiceAlertList, ...alertList, ...proAlertList, ...settingAlertList]
    }, [alertList, invoiceAlertList, settingAlertList, proAlertList])

    const openAlert = useCallback(() => {
        if (list?.length === 1) {
            list?.at(0)?.action()
            return
        }

        importantAlertModalRef?.current?.show()
    }, [])
    const openNoRegisteredApiModal = useCallback(() => {
        notRegisteredApiModalRef?.current?.show()
    }, [])
    const openSharePortfolioOptionModal = useCallback(() => {
        sharePortfolioOptionModalRef?.current?.show()
    }, [])

    return (
        <>
            <WizCustomViewMenu
                enableHover
                placement={'bottom'}
                baseChildren={<UserAccountComponent className={className} />}
                floatingStyle={{marginTop}}>
                <div
                    className={
                        'w-full min-w-[300px] shadow-normal bg-white dark:bg-bg_dark_popup dark:shadow-dark_normal rounded-[5px]'
                    }>
                    <UserAccountInfo
                        alertLength={list?.length}
                        openAlert={openAlert}
                        openNoRegisteredApiModal={openNoRegisteredApiModal}
                        openSharePortfolioOptionModal={openSharePortfolioOptionModal}
                    />
                    <AccountOperationPages />
                    <UserAccountList />
                    <UserLogOutOperations />
                </div>
            </WizCustomViewMenu>

            {/* Important alert modal */}
            <AccountImportantAlertModal ref={importantAlertModalRef} alertList={list} />

            {/* Share Portfolio Option Modal */}
            <SharePortfolioOptionModal ref={sharePortfolioOptionModalRef} />

            {/* Not Registered Api Modal */}
            <NotRegisteredApiModal ref={notRegisteredApiModalRef} />

            {/* 숨겨진 파일 선택 input (Floating UI 바깥에 위치) */}
            <UserAccountThumbnailChangeInput />
        </>
    )
}

export default NavigationAccountOperationMenu
